import { isPlatformServer, isPlatformBrowser } from "@angular/common";
import { OnInit, OnDestroy, Component, inject, PLATFORM_ID } from "@angular/core";
import { Subscription } from "rxjs";


@Component({ selector: '_newpla-base-component', template: '' })
export abstract class NewplaBaseComponent implements OnInit, OnDestroy {

    protected readonly _platformId = inject(PLATFORM_ID);
    protected _subscriptions: Subscription[] = [];

    protected _browserInitError: (err: any) => void = (err) => {
        alert('페이지 초기화를 실패했습니다.');
    };

    protected serverInitFn!: () => void;
    protected browserInitFn!: () => void;
    // --------------------------------------------------------------------------------------

    ngOnInit(): void {
        if (isPlatformServer(this._platformId)) { this.serverInitFn && this.serverInitFn() }
        if (isPlatformBrowser(this._platformId)) { this.browserInitFn && this.browserInitFn(); }
    }
    ngOnDestroy(): void { this._subscriptions.forEach((sb) => sb.unsubscribe()); }

}